import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { AuthData } from '../../models/auth-data.model';
import { AuthStorageService } from './auth-storage.service';
import { AuthApiService } from './auth-api.service';
import { UserRole } from '../../models/user-role.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private readonly authApiService: AuthApiService,
    private readonly authStorageService: AuthStorageService,
    private readonly router: Router,
  ) {}

  login(email: string, password: string, keepLogged: boolean): Observable<AuthData> {
    this.authStorageService.clearAuthData();
    return this.authApiService.login(email, password).pipe(
      tap(authData => {
        this.authStorageService.saveAuthData(authData, keepLogged);
      }),
    );
  }

  logout(redirectUrl: string | null = '/login'): void {
    this.authStorageService.clearAuthData();
    redirectUrl && this.router.navigateByUrl(redirectUrl);
  }

  isAuthenticated(role?: UserRole): boolean {
    if (role) {
      return !!this.authStorageService.getToken() && this.authStorageService.getUserRole() === role;
    } else {
      return !!this.authStorageService.getToken();
    }
  }

  getAuthData(): AuthData | null {
    return this.authStorageService.getAuthData();
  }

  saveAuthData(autData: AuthData, keepData: boolean): void {
    this.authStorageService.saveAuthData(autData, keepData);
  }
  clearAuthData(): void {
    this.authStorageService.clearAuthData();
  }
}
